export default __webpack_public_path__ + "static/media/mad-ape-007.d17b1a25.svg";